import React from "react";
import AlberoStrutturaMacrocategorieView from "./AlberoStrutturaMacrocategorieView";

export default function AlberoStrutturaMacrocategorieController({
                                                          treeData,
                                                          macrocategoriaSel,
                                                          translate,
                                                          history,
                                                          setMacrocategoriaSel,
                                                          setShowConfirm,
                                                      }) {

    const vociClickDestro = [
        {
            title: translate("Aggiungi figlio"),
            icon: "fas fa-plus",
            fun: (el) => {
                history.push("/add-macrocategoria-figlia/" + el.id + '/' + el.id_classe);
            }
        },
        {
            title: translate("Modifica"),
            icon: "fas fa-pen",
            fun: (el) => {
                history.push('/upd-macrocategoria/' + el.id);
            }
        },
        {
            title: translate("Elimina"),
            icon: "fas fa-trash",
            fun: (el) => {
                setMacrocategoriaSel(el);
                setShowConfirm(true);
            }
        },
    ];

    return (
        <AlberoStrutturaMacrocategorieView
            treeData={treeData}
            macrocategoriaSel={macrocategoriaSel}
            vociClickDestro={vociClickDestro}
        />
    );
}